import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { customerActions as c } from 'store/actions/dataSources';

import { isAuthenticated, getRole } from 'utils/auth';

const CustomerWrapper = ({ children }) => {
  const dispatch = useDispatch();

  React.useEffect(() => {
    if (isAuthenticated()) {
      const role = getRole();

      if (role) {
        const fetchCustomerData = async () => {
          await dispatch(c.fetchCustomerWithAddress(role.customerId));
        };

        fetchCustomerData();
      }
    }
  }, [dispatch]);

  return children;
};

CustomerWrapper.propTypes = {
  children: PropTypes.node.isRequired,
};

export default CustomerWrapper;
